"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIPv6Valid = exports.normalizeIpv6 = exports.getPreviousIpv6Range = exports.getNextIpv6Range = exports.getCurrentIpv6Range = void 0;

var _trim = _interopRequireDefault(require("lodash/trim"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description
 * Returns a range for IPv6 octet based on cursor position.
 * @Function
 *
 * @name skybase-components.sb-ipv6-input.utils#getCurrentIpv6Range
 * @param {String} text
 * @param {Number} position
 * @return {skybase-components.sb-ipv6-input.utils#Range}
 */
var getCurrentIpv6Range = function getCurrentIpv6Range(text, position) {
  var endIdx = text.indexOf(':', position) !== -1 ? text.indexOf(':', position) : text.length;
  var startIdx = text.lastIndexOf(':', position - 1) !== -1 ? text.lastIndexOf(':', position - 1) + 1 : 0;
  return [startIdx, endIdx];
};
/**
 * @description
 * Returns a range for next IPv6 octet based on cursor position.
 * @Function
 *
 * @name skybase-components.sb-ipv6-input.utils#getCurrentIpv6Range
 * @param {String} text
 * @param {Number} position
 * @return {skybase-components.sb-ipv6-input.utils#Range}
 */


exports.getCurrentIpv6Range = getCurrentIpv6Range;

var getNextIpv6Range = function getNextIpv6Range(text, position) {
  var nextIdx = text.indexOf(':', position) !== -1 ? text.indexOf(':', position) : text.length;
  var range = getCurrentIpv6Range(text, nextIdx + 1);
  return range;
};
/**
 * @description
 * Returns a range for previous IPv6 octet based on cursor position.
 * @Function
 *
 * @name skybase-components.sb-ipv6-input.utils#getCurrentIpv6Range
 * @param {String} text
 * @param {Number} position
 * @return {skybase-components.sb-ipv6-input.utils#Range}
 */


exports.getNextIpv6Range = getNextIpv6Range;

var getPreviousIpv6Range = function getPreviousIpv6Range(text, position) {
  var lastIdx = text.lastIndexOf(':', position - 1) !== -1 ? text.lastIndexOf(':', position - 1) + 1 : 0;
  var range = getCurrentIpv6Range(text, lastIdx - 1);
  return range;
};
/**
 * @description
 * Normalizes an IPv6 passed as string. It removes any unneccesarry spaces
 * and returns '00:00:00:00:00:00:00:00' if empty string is given.
 * @Function
 *
 * @name skybase-components.sb-ipv6-input.utils#getCurrentIpv6Range
 * @param {String} value
 * @return {skybase-components.sb-ipv6-input.utils#Range}
 */


exports.getPreviousIpv6Range = getPreviousIpv6Range;

var normalizeIpv6 = function normalizeIpv6(value) {
  if ((0, _trim.default)(value) === '') {
    return '00:00:00:00:00:00:00:00';
  }

  return (0, _trim.default)(value);
};
/**
 * @description
 * Validates an IPv6 passed as string. If passed valid IPv6 value, true is
 * returned. Otherwise false is returned.
 * @Function
 *
 * @name skybase-components.sb-ipv6-input.utils#getCurrentIpv6Range
 * @param {String} value
 * @return {skybase-components.sb-ipv6-input.utils#Range}
 */


exports.normalizeIpv6 = normalizeIpv6;

var isIPv6Valid = function isIPv6Valid(value) {
  var regexIPv6 = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  return regexIPv6.test(value);
};

exports.isIPv6Valid = isIPv6Valid;
//# sourceMappingURL=utils.js.map